import { theme } from "../../theme.js";

export default function Container({ children }){
    return(
        <div style={styles(theme).container}>{children}</div>
    )
};

const styles = (theme) => ({  container: {
    backgroundColor: theme.colors.white,
    minHeight: "100vh",
  },
});
